import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "utils";

export const fetchTotalCountsAction = async () => {
  const loggedInUser = getUserData();
  const loggedUserEmail = loggedInUser?.email || "";
  try {
    // const url = `${ATP_API_URL.SPOC_ACTIVE_INACTIVE}?userId=${id}&isActive=${activeFlag}`;
    // const response = await apiClient.get(ATP_API_URL.TOTAL_COUNTS);
    const response = await apiClient.get(
      `${ATP_API_URL.TOTAL_COUNTS}?userEmail=${loggedUserEmail}`,
    );

    if (response?.status === 200 && response.data?.success) {
      return {
        success: true,
        data: {
          totalServicePartner: response.data.totalServicePartner || 0,
          totalClients: response.data.totalClients || 0,
          totalPendings: response.data.totalPendings || 0,
          kycNotRequired: response.data.kycNotRequired || 0,
          totalActive:
            response.data.activeCases || response.data.totalActive || 0,
          totalInactive:
            response.data.inactiveCases || response.data.totalInactive || 0,
          kycSubmitted: response.data.kycSubmitted || 0,
        },
        message: response.data.message,
      };
    }

    return {
      success: false,
      data: {
        totalServicePartner: 0,
        totalClients: 0,
        totalPendings: 0,
        kycNotRequired: 0,
        totalActive: 0,
        totalInactive: 0,
        kycSubmitted: 0,
      },
      message: "Failed to fetch counts",
    };
  } catch (error) {
    return {
      success: false,
      data: {
        totalServicePartner: 0,
        totalClients: 0,
        totalPendings: 0,
        kycNotRequired: 0,
        kycSubmitted: 0,
        totalActive: 0,
        totalInactive: 0,
      },
      message: error.message || "Failed to fetch counts",
      error,
    };
  }
};
